import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorDisplay = ({ message }) => {
  if (!message) return null;
  
  // Проверяем, содержит ли сообщение просьбу перезагрузить фото
  const hasReloadRequest = message.includes('перезагрузите') || message.includes('повторите попытку');
  
  // Разделяем сообщение на две части: основную ошибку и инструкцию
  let errorMessage = message;
  let instruction = '';
  
  if (hasReloadRequest) {
    const parts = message.split('.');
    if (parts.length > 1) {
      errorMessage = parts[0] + '.';
      instruction = parts.slice(1).join('.').trim();
    }
  }

  return (
    <Box sx={{ my: 2 }}>
      <Alert 
        severity="error" 
        variant="outlined"
        icon={<ErrorOutlineIcon fontSize="inherit" />}
        sx={{
          borderRadius: 1,
          borderColor: '#bdbdbd',
          '& .MuiAlert-icon': {
            color: '#212121',
          },
        }}
      >
        <AlertTitle sx={{ fontWeight: 500, fontSize: '0.875rem', color: '#212121' }}>Ошибка</AlertTitle>
        <Box>
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            {errorMessage}
          </Typography>
          {instruction && (
            <Typography 
              variant="body2" 
              sx={{ 
                fontSize: '0.875rem', 
                fontWeight: 500,
                mt: 1,
                color: '#212121' 
              }}
            >
              {instruction}
            </Typography>
          )}
        </Box>
      </Alert>
    </Box>
  );
};

export default ErrorDisplay; 